// extracted by mini-css-extract-plugin
module.exports = {"minimumPackagesInput":"MinimumPackagesInput_minimumPackagesInput__FY6WG"};